import { extendTailwindMerge } from 'tailwind-merge'

import classNames, { ArgumentArray } from 'classnames'

import tailwindConfig from '@/tailwind.config'

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: { 'font-size': Object.keys(tailwindConfig.theme.extend.fontSize).map((key) => `text-${key}`) },
    },
})

export const cn = (...inputs: ArgumentArray) => twMerge(classNames(inputs))
